export default "__VITE_ASSET__CBbezHQI__"